export default __webpack_public_path__ + "static/media/pantry1-afterA-480w.3b11f980.avif";